import { Helmet } from "react-helmet";
import {
    useElementContext,
    useBrand,
} from "@ten24/slatwall-storefront-react-private/global";

const BrandSearchListing = ({ children, ...props }) => {
    const { ListingBanner, SearchListingStack } = useElementContext();
    const { brandResponse, slug, subHeading } = useBrand();

    return (
        <>
            {!!brandResponse.data?.at(0)?.settings?.brandHTMLTitleString && (
                <Helmet
                    title={brandResponse.data?.at(0)?.settings?.brandHTMLTitleString}
                />
            )}
            <ListingBanner
                subHeading={subHeading}
                heading={brandResponse?.data?.at(0)?.brandName}
                images={brandResponse?.data?.at(0)?.images}
                description={brandResponse?.data?.at(0)?.brandDescription}
            />
            {children}
            {brandResponse.isLoaded && brandResponse.data.length > 0 && (
                <SearchListingStack
                    hide="brand"
                    {...props}
                    initPreFilter={{
                        brand_slug: slug,
                    }}
                />
            )}
        </>
    );
};

export { BrandSearchListing };
